import { render } from "./Nested.vue?vue&type=template&id=fbdfc680&scoped=true"
import script from "./Nested.vue?vue&type=script&lang=js"
export * from "./Nested.vue?vue&type=script&lang=js"

import "./Nested.vue?vue&type=style&index=0&id=fbdfc680&scoped=true&lang=css"

import exportComponent from "/home/appfloretcollegein/app.floretcollege.in/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbdfc680"]])

export default __exports__